import { Store } from '@sama/app-state';
import { floor, round } from 'lodash';
import { map, switchMap } from 'rxjs';
import { ShapeState2D } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { selectionToArray } from '../../../cross-team-shared/misc-utils';
import { AbstractSensorContentStore } from '../../../cross-team-shared/state/abstract-sensor-content-store';
import { SensorFrame2D } from '../../../cross-team-shared/state/sensor-renderer-state';
import {
  AbstractSensorContentState2D,
  RasterOverlayState,
} from './abstract-sensor-content-state-2d';

export class AbstractSensorContentStore2D<
  T extends AbstractSensorContentState2D = AbstractSensorContentState2D,
> extends AbstractSensorContentStore<T, ShapeState2D, SensorFrame2D> {
  getFocusedShapeStore() {
    const index = this.getFocusedShapeIndex();
    if (!index) {
      return undefined;
    }
    // Because of a delay between the core / content teams shape
    // synchronization, the focused shape index can sometimes refer
    // to a non-existing shape.
    // fix me if you change this code
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    if (!this.state().shapes[index]) {
      return undefined;
    }
    return this('shapes')(index);
  }

  getFocusedShapeIndex() {
    const selection = selectionToArray(this.state().selection);
    return selection.length === 1 ? selection[0] : undefined;
  }

  getRasterOverlayStore(): Store<RasterOverlayState> {
    // This store only exists for outputs that have the overlay
    return this('rasterOverlay');
  }

  getLayerSettingsStore() {
    return this('layerSettings');
  }

  getViewBoxString$(isInsideZoomPanel = false) {
    let viewBox$ = this('viewBox').$;
    if (isInsideZoomPanel) {
      viewBox$ = this('zoomPanelViewBox').$;
    }
    return viewBox$.pipe(map((viewBox) => viewBox.join(' ')));
  }

  floorWithPixelSize(value: number) {
    return floor(value, this.getPixelFloatPrecision());
  }

  roundWithPixelSize(value: number) {
    return round(value, this.getPixelFloatPrecision());
  }

  getPixelFloatPrecision() {
    const [_unit, precision] = this.state()
      .pixelSize.toExponential()
      .split('e');
    return -precision;
  }

  protected buildFocusedShapeStore$() {
    return this('selection').$.pipe(map(() => this.getFocusedShapeStore()));
  }

  protected buildCurrentSensorFrame$() {
    return this('frameNumber').$.pipe(
      switchMap(
        (frameNumber) =>
          this('sensorRendererState')('sensorFrames')(frameNumber).$,
      ),
    );
  }
}
